import { Box, styled, Typography, useTheme } from "@mui/material";
import { RefObject } from "react";

interface OnBoardingItemProps {
  image: string;
  title: string;
  description: string;
  scrollRef: RefObject<HTMLDivElement>;
  inViewRef: RefObject<HTMLDivElement>;
}

const OnBoardingItem = ({
  image,
  title,
  description,
  inViewRef,
  scrollRef,
}: OnBoardingItemProps) => {
  const theme = useTheme();
  return (
    <Box
      ref={scrollRef}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        height: "100%",
        padding: "20px",
        minWidth: "100%",
        scrollSnapAlign: "start",
      }}>
      <Box sx={{ height: "24px" }} />
      <OnboardingImage
        ref={inViewRef as any}
        src={image}
        sx={{
          width: "300px",
          aspectRatio: "1/1",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "600px",
          // marginTop: "82px",
        }}>
        <Box>
          <Typography variant="title-h2" color={theme.palette.brand.primary}>
            {title}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body-md" color={theme.palette.text.secondary}>
            {description}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ height: "96px" }} />
    </Box>
  );
};

const OnboardingImage = styled("img")(({ theme }) => ({
  width: "80%",
  maxWidth: "400px",
  aspectRatio: "1/1",
}));

export { OnBoardingItem };
